import React from 'react';

export interface PromoPageListItemProps {
    text: string;
    href: string;
    className?: string;
}

export const PromoPageListItem: React.FC<PromoPageListItemProps> = ({text, href, className}) => (
    <li>
        <a href={href} className={className}>
            {text}
        </a>
    </li>
);
